// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════
   System Diagnostics Page
   ══════════════════════════════════════════════ */

.qts-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  background: #f8fafc;
  font-family: "Outfit", "Inter", sans-serif;
}
.dark .qts-page { background: #0f172a; }

/* ── Sticky header ── */
.qts-sticky-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: rgba(248, 250, 252, 0.92);
  border-bottom: 1px solid rgba(226, 232, 240, 0.7);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}
.dark .qts-sticky-header {
  background: rgba(15, 23, 42, 0.92);
  border-bottom-color: rgba(51, 65, 85, 0.7);
}

.qts-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 4rem;
  padding: 0 1.5rem;
}
.qts-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.qts-header-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.dark .qts-header-title { color: #f1f5f9; }

.qts-last-measured {
  font-size: 0.78rem;
  color: #94a3b8;
  font-weight: 500;
}
.dark .qts-last-measured { color: #64748b; }

/* ── Body ── */
.qts-body {
  padding: 1.5rem;
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  padding-bottom: 5rem;
}

/* ── 4-card metrics grid ── */
.qts-metrics-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 16px;
}
@media (max-width: 900px) { .qts-metrics-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 500px) { .qts-metrics-grid { grid-template-columns: 1fr; } }

.qts-metric-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 18px 18px 14px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.dark .qts-metric-card { background: #1e293b; border-color: #334155; }

.qts-metric-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.qts-metric-icon { color: #64748b; display: inline-flex; }
.dark .qts-metric-icon { color: #94a3b8; }

.qts-metric-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.qts-metric-dot--good { background: #22c55e; }
.qts-metric-dot--warn { background: #f59e0b; }
.qts-metric-dot--bad  { background: #ef4444; }
.qts-metric-dot--idle { background: #cbd5e1; }

.qts-metric-value {
  font-size: 1.75rem;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.1;
  letter-spacing: -0.02em;
}
.dark .qts-metric-value { color: #f1f5f9; }
.qts-metric-unit { font-size: 1rem; font-weight: 600; color: #475569; margin-left: 2px; }
.dark .qts-metric-unit { color: #94a3b8; }
.qts-metric-dash { color: #94a3b8; font-size: 1.5rem; }
.qts-metric-label { font-size: 0.85rem; font-weight: 600; color: #1e293b; margin-top: 2px; }
.dark .qts-metric-label { color: #e2e8f0; }
.qts-metric-sub { font-size: 0.75rem; color: #64748b; }

/* ══════════════════════════════════════════════
   Performance Snapshot Panel
   ══════════════════════════════════════════════ */
.qts-snapshot-panel {
  display: flex;
  align-items: flex-start;
  gap: 0;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 28px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
  margin-bottom: 16px;
}
.dark .qts-snapshot-panel { background: #1e293b; border-color: #334155; }

/* Left column: score ring + button */
.qts-snapshot-score-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 170px;
  flex-shrink: 0;
}

/* SVG ring */
.qts-score-ring { display: block; }
.qts-score-ring-bg { color: #f1f5f9; }
.dark .qts-score-ring-bg { color: #334155; }

.qts-score-label {
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  margin-top: 2px;
}
.qts-score-sub {
  font-size: 0.73rem;
  color: #94a3b8;
  font-weight: 500;
  text-align: center;
}

/* Run Diagnostics button */
.qts-diag-btn {
  margin-top: 12px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 20px;
  border-radius: 100px;
  border: none;
  background: #0f172a;
  color: #f8fafc;
  font-size: 0.83rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  white-space: nowrap;
}
.qts-diag-btn:hover { background: #1e293b; }
.qts-diag-btn:active { transform: scale(0.97); }
.qts-diag-btn:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
.dark .qts-diag-btn { background: #334155; color: #f1f5f9; }
.dark .qts-diag-btn:hover { background: #475569; }

.qts-diag-btn--running { background: #1e40af; }
.dark .qts-diag-btn--running { background: #1d4ed8; }

/* Spinner inside button */
@keyframes qts-spin { to { transform: rotate(360deg); } }
.qts-diag-spinner {
  display: inline-block;
  width: 13px;
  height: 13px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: qts-spin 0.7s linear infinite;
  flex-shrink: 0;
}

/* Diagnostics step list */
.qts-diag-steps {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 10px;
  width: 100%;
}
.qts-diag-step {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 0.73rem;
  color: #94a3b8;
  padding: 3px 0;
  transition: color 0.2s;
}
.qts-diag-step.active { color: #3b82f6; font-weight: 600; }
.qts-diag-step.done   { color: #22c55e; }

.qts-diag-step-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  background: currentColor;
}
.qts-diag-step.active .qts-diag-step-dot {
  background: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
  animation: qts-pulse 1s ease-in-out infinite;
}
@keyframes qts-pulse { 0%,100% { box-shadow: 0 0 0 3px rgba(59,130,246,0.25); } 50% { box-shadow: 0 0 0 6px rgba(59,130,246,0.1); } }

.qts-diag-step-label { line-height: 1.3; }

/* "Diagnostics complete" confirmation */
.qts-diag-done {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.73rem;
  color: #22c55e;
  font-weight: 600;
  margin-top: 4px;
}

/* Vertical divider */
.qts-snapshot-divider {
  width: 1px;
  background: #e2e8f0;
  align-self: stretch;
  margin: 0 28px;
  flex-shrink: 0;
}
.dark .qts-snapshot-divider { background: #334155; }

/* Right column: metric bars */
.qts-snapshot-bars-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}
.qts-snap-col-title {
  font-size: 0.78rem;
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 4px;
}
.dark .qts-snap-col-title { color: #64748b; }

/* Individual snapshot row */
.qts-snap-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.qts-snap-row-left {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 148px;
  flex-shrink: 0;
}
.qts-snap-icon { display: inline-flex; flex-shrink: 0; }
.qts-snap-meta { display: flex; flex-direction: column; gap: 1px; min-width: 0; }
.qts-snap-name {
  font-size: 0.82rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dark .qts-snap-name { color: #e2e8f0; }
.qts-snap-thresh {
  font-size: 0.68rem;
  color: #94a3b8;
  white-space: nowrap;
}

.qts-snap-bar-wrap { flex: 1; min-width: 0; }
.qts-snap-bar-track {
  height: 7px;
  background: #f1f5f9;
  border-radius: 99px;
  overflow: hidden;
}
.dark .qts-snap-bar-track { background: #0f172a; }
.qts-snap-bar-fill {
  height: 100%;
  border-radius: 99px;
  transition: width 0.8s cubic-bezier(.4,0,.2,1), background 0.4s;
}

.qts-snap-value {
  font-size: 0.82rem;
  font-weight: 700;
  width: 70px;
  text-align: right;
  flex-shrink: 0;
  white-space: nowrap;
}

/* Responsive: stack on small screens */
@media (max-width: 720px) {
  .qts-snapshot-panel { flex-direction: column; }
  .qts-snapshot-divider { width: 100%; height: 1px; margin: 20px 0; }
  .qts-snap-row-left { width: 120px; }
}

/* ══════════════════════════════════════════════
   Bottom row (Risks + Tips)
   ══════════════════════════════════════════════ */
.qts-bottom-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 18px;
}
@media (max-width: 720px) { .qts-bottom-row { grid-template-columns: 1fr; } }

.qts-panel {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.dark .qts-panel { background: #1e293b; border-color: #334155; }

.qts-panel-header {
  display: flex;
  align-items: center;
  gap: 8px;
}
.qts-panel-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
  flex: 1;
}
.dark .qts-panel-title { color: #e2e8f0; }

/* Risk count badge */
.qts-risk-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ef4444;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
}

/* Risk rows */
.qts-risk-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  background: transparent;
}
.qts-risk-row--warn  { background: #fffbeb; }
.qts-risk-row--error { background: #fef2f2; }
.dark .qts-risk-row--warn  { background: rgba(245, 158, 11, 0.12); }
.dark .qts-risk-row--error { background: rgba(239, 68, 68, 0.12); }

.qts-risk-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; margin-top: 5px; }
.qts-risk-dot--good  { background: #22c55e; }
.qts-risk-dot--warn  { background: #f59e0b; }
.qts-risk-dot--error { background: #ef4444; }

.qts-risk-title { font-size: 0.85rem; font-weight: 600; color: #1e293b; }
.qts-risk-row--warn  .qts-risk-title { color: #92400e; }
.qts-risk-row--error .qts-risk-title { color: #991b1b; }
.dark .qts-risk-title { color: #e2e8f0; }
.dark .qts-risk-row--warn  .qts-risk-title { color: #fbbf24; }
.dark .qts-risk-row--error .qts-risk-title { color: #f87171; }

.qts-risk-desc { font-size: 0.78rem; color: #64748b; margin-top: 2px; line-height: 1.4; }
.dark .qts-risk-desc { color: #94a3b8; }

/* Danger zone */
.qts-danger-zone { margin-top: auto; padding-top: 8px; border-top: 1px solid #f1f5f9; }
.dark .qts-danger-zone { border-top-color: #334155; }

.qts-danger-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-radius: 8px;
  border: 1px solid #fecaca;
  background: #fff5f5;
  color: #dc2626;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.qts-danger-btn:hover { background: #fee2e2; }
.dark .qts-danger-btn { background: rgba(220,38,38,0.1); border-color: rgba(220,38,38,0.3); color: #f87171; }
.dark .qts-danger-btn:hover { background: rgba(220,38,38,0.18); }

/* Troubleshooting tips */
.qts-tips-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
}
.qts-tip-item { display: flex; align-items: flex-start; gap: 10px; }
.qts-tip-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #eff6ff;
  color: #2563eb;
  font-size: 0.72rem;
  font-weight: 700;
  flex-shrink: 0;
}
.dark .qts-tip-num { background: rgba(37,99,235,0.2); color: #60a5fa; }
.qts-tip-text { font-size: 0.85rem; color: #334155; line-height: 1.45; }
.dark .qts-tip-text { color: #cbd5e1; }

/* ── System Info block ── */
.qts-sysinfo {
  margin-top: auto;
  padding-top: 14px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.dark .qts-sysinfo { border-top-color: #334155; }

.qts-sysinfo-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.dark .qts-sysinfo-header { color: #64748b; }

.qts-sysinfo-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 12px;
}

.qts-sysinfo-row {
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 8px;
  padding: 7px 10px;
}
.dark .qts-sysinfo-row { background: #0f172a; border-color: #1e293b; }

.qts-sysinfo-key {
  font-size: 0.68rem;
  color: #94a3b8;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.qts-sysinfo-val {
  font-size: 0.82rem;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dark .qts-sysinfo-val { color: #e2e8f0; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/QuickTroubleshoot/index.css"],"names":[],"mappings":"AAAA;;mDAEmD;;AAEnD;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;AAC5C;AACA,kBAAkB,mBAAmB,EAAE;;AAEvC,wBAAwB;AACxB;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,qCAAqC;EACrC,iDAAiD;EACjD,2BAA2B;EAC3B,mCAAmC;AACrC;AACA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA,0BAA0B,cAAc,EAAE;;AAE1C;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA,2BAA2B,cAAc,EAAE;;AAE3C,eAAe;AACf;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;AACA,4BAA4B,oBAAoB,qCAAqC,EAAE,EAAE;AACzF,4BAA4B,oBAAoB,0BAA0B,EAAE,EAAE;;AAE9E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,yBAAyB,mBAAmB,EAAE,qBAAqB,EAAE;;AAErE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA,mBAAmB,cAAc,EAAE,oBAAoB,EAAE;AACzD,yBAAyB,cAAc,EAAE;;AAEzC,kBAAkB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAC/E,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;AACA,0BAA0B,cAAc,EAAE;AAC1C,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACxF,yBAAyB,cAAc,EAAE;AACzC,mBAAmB,cAAc,EAAE,iBAAiB,EAAE;AACtD,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC3F,0BAA0B,cAAc,EAAE;AAC1C,kBAAkB,kBAAkB,EAAE,cAAc,EAAE;;AAEtD;;mDAEmD;AACnD;EACE,aAAa;EACb,uBAAuB;EACvB,MAAM;EACN,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,mBAAmB;AACrB;AACA,4BAA4B,mBAAmB,EAAE,qBAAqB,EAAE;;AAExE,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA,aAAa;AACb,kBAAkB,cAAc,EAAE;AAClC,qBAAqB,cAAc,EAAE;AACrC,2BAA2B,cAAc,EAAE;;AAE3C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;AACrB;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,uBAAuB,sBAAsB,EAAE;AAC/C,yBAAyB,YAAY,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC7E,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,4BAA4B,mBAAmB,EAAE;;AAEjD,yBAAyB,mBAAmB,EAAE;AAC9C,+BAA+B,mBAAmB,EAAE;;AAEpD,0BAA0B;AAC1B,sBAAsB,KAAK,yBAAyB,EAAE,EAAE;AACxD;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;AACA,wBAAwB,cAAc,EAAE,gBAAgB,EAAE;AAC1D,wBAAwB,cAAc,EAAE;;AAExC;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,4CAA4C;AAC9C;AACA,uBAAuB,UAAU,2CAA2C,EAAE,EAAE,MAAM,0CAA0C,EAAE,EAAE;;AAEpI,uBAAuB,gBAAgB,EAAE;;AAEzC,wCAAwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;AACA,8BAA8B,mBAAmB,EAAE;;AAEnD,8BAA8B;AAC9B;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;AACA,4BAA4B,cAAc,EAAE;;AAE5C,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;AACA,iBAAiB,oBAAoB,EAAE,cAAc,EAAE;AACvD,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAChF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,uBAAuB,cAAc,EAAE;AACvC;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,qBAAqB,OAAO,EAAE,YAAY,EAAE;AAC5C;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,4BAA4B,mBAAmB,EAAE;AACjD;EACE,YAAY;EACZ,mBAAmB;EACnB,+DAA+D;AACjE;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,sBAAsB,sBAAsB,EAAE;EAC9C,wBAAwB,WAAW,EAAE,WAAW,EAAE,cAAc,EAAE;EAClE,qBAAqB,YAAY,EAAE;AACrC;;AAEA;;mDAEmD;AACnD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA,4BAA4B,kBAAkB,0BAA0B,EAAE,EAAE;;AAE5E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA,mBAAmB,mBAAmB,EAAE,qBAAqB,EAAE;;AAE/D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,OAAO;AACT;AACA,yBAAyB,cAAc,EAAE;;AAEzC,qBAAqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,6BAA6B,oCAAoC,EAAE;AACnE,6BAA6B,mCAAmC,EAAE;;AAElE,gBAAgB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC9F,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;;AAE5C,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACxE,uCAAuC,cAAc,EAAE;AACvD,uCAAuC,cAAc,EAAE;AACvD,wBAAwB,cAAc,EAAE;AACxC,6CAA6C,cAAc,EAAE;AAC7D,6CAA6C,cAAc,EAAE;;AAE7D,iBAAiB,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACxF,uBAAuB,cAAc,EAAE;;AAEvC,gBAAgB;AAChB,mBAAmB,gBAAgB,EAAE,gBAAgB,EAAE,6BAA6B,EAAE;AACtF,yBAAyB,yBAAyB,EAAE;;AAEpD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,+BAA+B,EAAE,iCAAiC,EAAE,cAAc,EAAE;AAC5G,8BAA8B,gCAAgC,EAAE;;AAEhE,yBAAyB;AACzB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;AACT;AACA,gBAAgB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE;AACnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA,qBAAqB,+BAA+B,EAAE,cAAc,EAAE;AACtE,gBAAgB,kBAAkB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AACvE,sBAAsB,cAAc,EAAE;;AAEtC,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA,qBAAqB,yBAAyB,EAAE;;AAEhD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;AACA,4BAA4B,cAAc,EAAE;;AAE5C;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;AACA,yBAAyB,mBAAmB,EAAE,qBAAqB,EAAE;;AAErE;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,yBAAyB,cAAc,EAAE","sourcesContent":["/* ══════════════════════════════════════════════\n   System Diagnostics Page\n   ══════════════════════════════════════════════ */\n\n.qts-page {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  width: 100%;\n  box-sizing: border-box;\n  background: #f8fafc;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n.dark .qts-page { background: #0f172a; }\n\n/* ── Sticky header ── */\n.qts-sticky-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: rgba(248, 250, 252, 0.92);\n  border-bottom: 1px solid rgba(226, 232, 240, 0.7);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n}\n.dark .qts-sticky-header {\n  background: rgba(15, 23, 42, 0.92);\n  border-bottom-color: rgba(51, 65, 85, 0.7);\n}\n\n.qts-header-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 4rem;\n  padding: 0 1.5rem;\n}\n.qts-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.qts-header-title {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n.dark .qts-header-title { color: #f1f5f9; }\n\n.qts-last-measured {\n  font-size: 0.78rem;\n  color: #94a3b8;\n  font-weight: 500;\n}\n.dark .qts-last-measured { color: #64748b; }\n\n/* ── Body ── */\n.qts-body {\n  padding: 1.5rem;\n  max-width: 1100px;\n  width: 100%;\n  margin: 0 auto;\n  box-sizing: border-box;\n  padding-bottom: 5rem;\n}\n\n/* ── 4-card metrics grid ── */\n.qts-metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n  margin-bottom: 16px;\n}\n@media (max-width: 900px) { .qts-metrics-grid { grid-template-columns: repeat(2, 1fr); } }\n@media (max-width: 500px) { .qts-metrics-grid { grid-template-columns: 1fr; } }\n\n.qts-metric-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 18px 18px 14px;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.dark .qts-metric-card { background: #1e293b; border-color: #334155; }\n\n.qts-metric-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n.qts-metric-icon { color: #64748b; display: inline-flex; }\n.dark .qts-metric-icon { color: #94a3b8; }\n\n.qts-metric-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }\n.qts-metric-dot--good { background: #22c55e; }\n.qts-metric-dot--warn { background: #f59e0b; }\n.qts-metric-dot--bad  { background: #ef4444; }\n.qts-metric-dot--idle { background: #cbd5e1; }\n\n.qts-metric-value {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n}\n.dark .qts-metric-value { color: #f1f5f9; }\n.qts-metric-unit { font-size: 1rem; font-weight: 600; color: #475569; margin-left: 2px; }\n.dark .qts-metric-unit { color: #94a3b8; }\n.qts-metric-dash { color: #94a3b8; font-size: 1.5rem; }\n.qts-metric-label { font-size: 0.85rem; font-weight: 600; color: #1e293b; margin-top: 2px; }\n.dark .qts-metric-label { color: #e2e8f0; }\n.qts-metric-sub { font-size: 0.75rem; color: #64748b; }\n\n/* ══════════════════════════════════════════════\n   Performance Snapshot Panel\n   ══════════════════════════════════════════════ */\n.qts-snapshot-panel {\n  display: flex;\n  align-items: flex-start;\n  gap: 0;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n  padding: 28px;\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);\n  margin-bottom: 16px;\n}\n.dark .qts-snapshot-panel { background: #1e293b; border-color: #334155; }\n\n/* Left column: score ring + button */\n.qts-snapshot-score-col {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  min-width: 170px;\n  flex-shrink: 0;\n}\n\n/* SVG ring */\n.qts-score-ring { display: block; }\n.qts-score-ring-bg { color: #f1f5f9; }\n.dark .qts-score-ring-bg { color: #334155; }\n\n.qts-score-label {\n  font-size: 1.1rem;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  margin-top: 2px;\n}\n.qts-score-sub {\n  font-size: 0.73rem;\n  color: #94a3b8;\n  font-weight: 500;\n  text-align: center;\n}\n\n/* Run Diagnostics button */\n.qts-diag-btn {\n  margin-top: 12px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 20px;\n  border-radius: 100px;\n  border: none;\n  background: #0f172a;\n  color: #f8fafc;\n  font-size: 0.83rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, transform 0.1s;\n  white-space: nowrap;\n}\n.qts-diag-btn:hover { background: #1e293b; }\n.qts-diag-btn:active { transform: scale(0.97); }\n.qts-diag-btn:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }\n.dark .qts-diag-btn { background: #334155; color: #f1f5f9; }\n.dark .qts-diag-btn:hover { background: #475569; }\n\n.qts-diag-btn--running { background: #1e40af; }\n.dark .qts-diag-btn--running { background: #1d4ed8; }\n\n/* Spinner inside button */\n@keyframes qts-spin { to { transform: rotate(360deg); } }\n.qts-diag-spinner {\n  display: inline-block;\n  width: 13px;\n  height: 13px;\n  border: 2px solid rgba(255,255,255,0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: qts-spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n\n/* Diagnostics step list */\n.qts-diag-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 10px;\n  width: 100%;\n}\n.qts-diag-step {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 0.73rem;\n  color: #94a3b8;\n  padding: 3px 0;\n  transition: color 0.2s;\n}\n.qts-diag-step.active { color: #3b82f6; font-weight: 600; }\n.qts-diag-step.done   { color: #22c55e; }\n\n.qts-diag-step-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: currentColor;\n}\n.qts-diag-step.active .qts-diag-step-dot {\n  background: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);\n  animation: qts-pulse 1s ease-in-out infinite;\n}\n@keyframes qts-pulse { 0%,100% { box-shadow: 0 0 0 3px rgba(59,130,246,0.25); } 50% { box-shadow: 0 0 0 6px rgba(59,130,246,0.1); } }\n\n.qts-diag-step-label { line-height: 1.3; }\n\n/* \"Diagnostics complete\" confirmation */\n.qts-diag-done {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.73rem;\n  color: #22c55e;\n  font-weight: 600;\n  margin-top: 4px;\n}\n\n/* Vertical divider */\n.qts-snapshot-divider {\n  width: 1px;\n  background: #e2e8f0;\n  align-self: stretch;\n  margin: 0 28px;\n  flex-shrink: 0;\n}\n.dark .qts-snapshot-divider { background: #334155; }\n\n/* Right column: metric bars */\n.qts-snapshot-bars-col {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n.qts-snap-col-title {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #64748b;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n.dark .qts-snap-col-title { color: #64748b; }\n\n/* Individual snapshot row */\n.qts-snap-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.qts-snap-row-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 148px;\n  flex-shrink: 0;\n}\n.qts-snap-icon { display: inline-flex; flex-shrink: 0; }\n.qts-snap-meta { display: flex; flex-direction: column; gap: 1px; min-width: 0; }\n.qts-snap-name {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #1e293b;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dark .qts-snap-name { color: #e2e8f0; }\n.qts-snap-thresh {\n  font-size: 0.68rem;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n\n.qts-snap-bar-wrap { flex: 1; min-width: 0; }\n.qts-snap-bar-track {\n  height: 7px;\n  background: #f1f5f9;\n  border-radius: 99px;\n  overflow: hidden;\n}\n.dark .qts-snap-bar-track { background: #0f172a; }\n.qts-snap-bar-fill {\n  height: 100%;\n  border-radius: 99px;\n  transition: width 0.8s cubic-bezier(.4,0,.2,1), background 0.4s;\n}\n\n.qts-snap-value {\n  font-size: 0.82rem;\n  font-weight: 700;\n  width: 70px;\n  text-align: right;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n/* Responsive: stack on small screens */\n@media (max-width: 720px) {\n  .qts-snapshot-panel { flex-direction: column; }\n  .qts-snapshot-divider { width: 100%; height: 1px; margin: 20px 0; }\n  .qts-snap-row-left { width: 120px; }\n}\n\n/* ══════════════════════════════════════════════\n   Bottom row (Risks + Tips)\n   ══════════════════════════════════════════════ */\n.qts-bottom-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  margin-bottom: 18px;\n}\n@media (max-width: 720px) { .qts-bottom-row { grid-template-columns: 1fr; } }\n\n.qts-panel {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.dark .qts-panel { background: #1e293b; border-color: #334155; }\n\n.qts-panel-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.qts-panel-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #1e293b;\n  flex: 1;\n}\n.dark .qts-panel-title { color: #e2e8f0; }\n\n/* Risk count badge */\n.qts-risk-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #ef4444;\n  color: #fff;\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n/* Risk rows */\n.qts-risk-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: transparent;\n}\n.qts-risk-row--warn  { background: #fffbeb; }\n.qts-risk-row--error { background: #fef2f2; }\n.dark .qts-risk-row--warn  { background: rgba(245, 158, 11, 0.12); }\n.dark .qts-risk-row--error { background: rgba(239, 68, 68, 0.12); }\n\n.qts-risk-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; margin-top: 5px; }\n.qts-risk-dot--good  { background: #22c55e; }\n.qts-risk-dot--warn  { background: #f59e0b; }\n.qts-risk-dot--error { background: #ef4444; }\n\n.qts-risk-title { font-size: 0.85rem; font-weight: 600; color: #1e293b; }\n.qts-risk-row--warn  .qts-risk-title { color: #92400e; }\n.qts-risk-row--error .qts-risk-title { color: #991b1b; }\n.dark .qts-risk-title { color: #e2e8f0; }\n.dark .qts-risk-row--warn  .qts-risk-title { color: #fbbf24; }\n.dark .qts-risk-row--error .qts-risk-title { color: #f87171; }\n\n.qts-risk-desc { font-size: 0.78rem; color: #64748b; margin-top: 2px; line-height: 1.4; }\n.dark .qts-risk-desc { color: #94a3b8; }\n\n/* Danger zone */\n.qts-danger-zone { margin-top: auto; padding-top: 8px; border-top: 1px solid #f1f5f9; }\n.dark .qts-danger-zone { border-top-color: #334155; }\n\n.qts-danger-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  border-radius: 8px;\n  border: 1px solid #fecaca;\n  background: #fff5f5;\n  color: #dc2626;\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.qts-danger-btn:hover { background: #fee2e2; }\n.dark .qts-danger-btn { background: rgba(220,38,38,0.1); border-color: rgba(220,38,38,0.3); color: #f87171; }\n.dark .qts-danger-btn:hover { background: rgba(220,38,38,0.18); }\n\n/* Troubleshooting tips */\n.qts-tips-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n}\n.qts-tip-item { display: flex; align-items: flex-start; gap: 10px; }\n.qts-tip-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #eff6ff;\n  color: #2563eb;\n  font-size: 0.72rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n.dark .qts-tip-num { background: rgba(37,99,235,0.2); color: #60a5fa; }\n.qts-tip-text { font-size: 0.85rem; color: #334155; line-height: 1.45; }\n.dark .qts-tip-text { color: #cbd5e1; }\n\n/* ── System Info block ── */\n.qts-sysinfo {\n  margin-top: auto;\n  padding-top: 14px;\n  border-top: 1px solid #f1f5f9;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.dark .qts-sysinfo { border-top-color: #334155; }\n\n.qts-sysinfo-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #64748b;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n.dark .qts-sysinfo-header { color: #64748b; }\n\n.qts-sysinfo-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px 12px;\n}\n\n.qts-sysinfo-row {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  background: #f8fafc;\n  border: 1px solid #f1f5f9;\n  border-radius: 8px;\n  padding: 7px 10px;\n}\n.dark .qts-sysinfo-row { background: #0f172a; border-color: #1e293b; }\n\n.qts-sysinfo-key {\n  font-size: 0.68rem;\n  color: #94a3b8;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.qts-sysinfo-val {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #1e293b;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dark .qts-sysinfo-val { color: #e2e8f0; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
